<template>
  <div class="">
      <Modal :is-open="true" :showBackButton="false" modelPopupClass="tw-max-w-3xl" :showCloseButton="false">
        <div class="tw-text-secondary tw-text-lg tw-leading-6 tw-space-y-4 tw-font-helvetica">
          <h2 class="tw-text-primary tw-font-semibold tw-leading-9">
            LET’S BEGIN!
          </h2>

          <p>
            To showcase the portal's many capabilities, we decided to add 3 different tutorials
            with the most common items ordered. The items we chose to showcase are:
          </p>
          <ul class="tw-space-y-2 tw-ml-6">
            <li><svg-icon name="solid/circle" class="tw-text-xs tw-w-1" /> Diamond Grille Hinged Door</li>
            <li><svg-icon name="solid/circle" class="tw-text-xs tw-w-1" /> 316 Stainless Steel Mesh Sliding Door Set - OXX</li>
            <li><svg-icon name="solid/circle" class="tw-text-xs tw-w-1" /> Insect Screen Window 9mm</li>
          </ul>
        </div>
        <template v-slot:footer>
          <div class="tw-mt-4">
            <button @click="start" class="btn btn_transparent tw-m-0 tw-flex tw-items-center">
              <svg-icon name="solid/step-forward"/> <span class="tw-ml-2">NEXT</span>
            </button>
          </div>
        </template>
      </Modal>
  </div>

</template>

<script>
import Modal from '@/components/modals/Generic'
export default {
    name: 'DemoWizard',
    components: {
        Modal
    },
    methods: {
      start() {
          this.$store.commit('demoWizard/nextStep')
      }
    }
}
</script>

<style lang="scss">

</style>
